import React from 'react';
import './HamburgerButton.scss';

export const HamburgerButton = ({ isOpen }) => {
  return (
    <button
      className={`hamburger ${isOpen ? 'hamburger--active' : ''}`}
      aria-label="Abrir ou fechar menu de navegação"
      aria-expanded={isOpen}
    >
      <span className="hamburger__line"></span>
      <span className="hamburger__line"></span>
      <span className="hamburger__line"></span>
    </button>
  );
};
